import React, { Fragment, useRef, useEffect, useState } from "react";
// import { useTranslation } from "react-i18next";
import Button from "@mui/material/Button";
import Card from "@mui/material/Card";
import { Box, IconButton, Typography, alpha, styled } from "@mui/material";
import Drawer from "@mui/material/Drawer";
import { IsMobile } from "./../../../../utils/utils";
import lottie from "lottie-web";
import { AVATAR_ANIMATION } from "../../../../constants/animations";
import { useTranslation } from "react-i18next";
import ExitToAppIcon from "@mui/icons-material/ExitToApp";
import Moment from "moment";
import Menu from "@mui/material/Menu";
import MenuItem from "@mui/material/MenuItem";
import ReactCountryFlag from "react-country-flag";
import classes from "./userMenu.module.scss";
import { HEADER_HEIGHT } from "../../../../constants/ui";
import { useDispatch, useSelector } from "react-redux";
import { setChangePassword, showOwnResponsivasReducer } from "../../../../store/reducers/app";
import { getGlobalCsrToken } from "../../../../api";
import { urlFormLogout } from "../../../../api/urls";
import ResponsivasIcon from "@mui/icons-material/AssignmentOutlined";
import packageJson from "../../../../../package.json";

const StyledMenu = styled((props) => (
  <Menu
    elevation={0}
    anchorOrigin={{
      vertical: "bottom",
      horizontal: "right",
    }}
    transformOrigin={{
      vertical: "top",
      horizontal: "right",
    }}
    {...props}
  />
))(({ theme }) => ({
  "& .MuiPaper-root": {
    borderRadius: 6,
    marginTop: theme.spacing(1),
    minWidth: 180,
    color: theme.palette.mode === "light" ? "rgb(55, 65, 81)" : theme.palette.grey[300],
    boxShadow:
      "rgb(255, 255, 255) 0px 0px 0px 0px, rgba(0, 0, 0, 0.05) 0px 0px 0px 1px, rgba(0, 0, 0, 0.1) 0px 10px 15px -3px, rgba(0, 0, 0, 0.05) 0px 4px 6px -2px",
    "& .MuiMenu-list": {
      padding: "4px 0",
    },
    "& .MuiMenuItem-root": {
      "& .MuiSvgIcon-root": {
        fontSize: 18,
        color: theme.palette.text.secondary,
        marginRight: theme.spacing(1.5),
      },
      "&:active": {
        backgroundColor: alpha(theme.palette.primary.main, theme.palette.action.selectedOpacity),
      },
    },
  },
}));

const UserMenu = (props) => {
  const { open, user, onLogout, onClose, menuPosition } = props;
  const { t, i18n } = useTranslation();
  // const { t } = useTranslation();
  const isMobile = IsMobile();
  const animationRef = useRef(null);
  const avatarAnimationRef = useRef(null);
  const [lang, setLang] = useState(user.getLang());
  const darkMode = useSelector((state) => state.app.darkMode);
  const [anchorEl, setAnchorEl] = React.useState(null);
  const openLangMenu = Boolean(anchorEl);
  const dispatch = useDispatch();
  const handleClick = (event) => {
    stopPropagation(event);
    setAnchorEl(event.currentTarget);
  };
  const handleClose = () => {
    setAnchorEl(null);
  };

  const stopPropagation = (e) => {
    e.stopPropagation();
    e.preventDefault();
  };

  useEffect(() => {
    if (animationRef.current) {
      avatarAnimationRef.current = lottie.loadAnimation({
        container: animationRef.current,
        renderer: "svg",
        loop: false,
        autoplay: true,
        path: AVATAR_ANIMATION,
      });
    }
  }, []);

  useEffect(() => {
    if (open && avatarAnimationRef.current) {
      avatarAnimationRef.current.goToAndStop(0);
      avatarAnimationRef.current.play();
    }
  }, [open]);

  useEffect(() => {
    handleClose();
    onClose();
  }, [darkMode]);

  const changeLangHandler = (langIso) => {
    //actualizamos usuario
    // dispatch(setAppLoading(true));
    handleClose();
    setTimeout(() => {
      // changeUserLang(dispatch, langIso)
      //   .then(() => {
      // console.log("R: ", r);
      setLang(langIso);
      i18n.changeLanguage(langIso);
      Moment.locale(langIso === "en" ? "en-gb" : langIso);
      onClose();
      //     })
      //     .catch((e) => {
      //       console.error("Error change user lang: ", e);
      //       errorRetryAlert({ t: t, onRetry: () => changeLangHandler(langIso) });
      //     })
      //     .finally(() => {
      //       dispatch(setAppLoading(false));
      //     });
    }, 500);
  };

  const showResponsivasHandler = () => {
    dispatch(showOwnResponsivasReducer(true));
  };

  const showChangePasswordHandler = (e) => {
    stopPropagation(e);
    onClose();
    dispatch(setChangePassword(true));
  };

  const userMenuContent = () => {
    return (
      <Fragment>
        <div className="d-flex p-3" onClick={stopPropagation}>
          <Box
            className={[classes.userImage, "bg-cover"].join(" ")}
            ref={!user.getImage() ? animationRef : null}
            sx={user.getImage() ? { background: `url(${user.getImage()})` } : {}}
          />
          <div className="flex-grow-1 d-flex flex-column ml-3">
            <Typography variant="h6" color="primary">
              {user.getFullName() || "-"}
            </Typography>
            <Typography variant="subtitle1" color="textSecondary" className="lh-1 user-menu-email">
              {user.getEmail() || "-"}
            </Typography>
            <Typography variant="caption" className="text-right">
              v{packageJson.version}
            </Typography>
            <div className="d-flex flex-column align-items-start">
              <IconButton onClick={handleClick} sx={{ width: "50px", height: "50px" }}>
                <CountryFlag code={lang === "en" ? "gb" : lang} />
              </IconButton>
              {/* <ButtonGroup variant="outlined">
                <Button onClick={() => dispatch(setDarkMode(false))} variant={darkMode ? "outlined" : "contained"}>
                  <LightModeOutlinedIcon />
                </Button>
                <Button onClick={() => dispatch(setDarkMode(true))} variant={darkMode ? "contained" : "outlined"}>
                  <DarkModeOutlinedIcon />
                </Button>
              </ButtonGroup> */}
              <StyledMenu
                id="demo-customized-menu"
                MenuListProps={{
                  "aria-labelledby": "demo-customized-button",
                }}
                anchorEl={anchorEl}
                open={openLangMenu}
                onClose={handleClose}
              >
                <MenuItem onClick={() => changeLangHandler("es")}>
                  <CountryFlag code="es" />
                  {t("langs.es")}
                </MenuItem>
                <MenuItem onClick={() => changeLangHandler("en")}>
                  <CountryFlag code="gb" />
                  {t("langs.en")}
                </MenuItem>

                <MenuItem onClick={() => changeLangHandler("it")}>
                  <CountryFlag code="it" />
                  {t("langs.it")}
                </MenuItem>
              </StyledMenu>
            </div>

            <Button size="small" color="inherit" onClick={showResponsivasHandler} variant="outlined" className="mt-2">
              <ResponsivasIcon className={!isMobile ? "mr-2" : ""} />
              {t("actions.myResponsives")}
            </Button>
          </div>
        </div>
        <div className={["d-flex align-items-center justify-content-between p-2", classes.footerContainer].join(" ")}>
          {!user.isCorporative() && (
            <Button size="small" color="inherit" onClick={showChangePasswordHandler}>
              {t("actions.changePassword")}
            </Button>
          )}
          <form id="logoutForm" action={urlFormLogout} method="post">
            <Button
              data-tut="user-menu-logout"
              variant="outlined"
              size="small"
              type="submit"
              className="w-100 text-transform-none"
            >
              <ExitToAppIcon className="text-light-color mr-2" />
              <Typography color="textSecondary">{t("actions.logout")}</Typography>
            </Button>
            <input type="hidden" name="redirect" value="landingpage" />
            <input type="hidden" name="_csrf" value={getGlobalCsrToken()} />
          </form>
        </div>
        {/* <div
          className={[
            "d-flex align-items-center justify-content-between p-2",
            classes.footerContainer,
          ].join(" ")}
        >
          <Button
            data-tut="user-menu-change-password"
            size="small"
            className="text-transform-none"
            onClick={() => {}}
          >
            <span className="button-text text-transform-none text-color btn-custom">
              Cambiar contraseña
            </span>
          </Button>
          <Button
            variant="outlined"
            size="small"
            className={["text-transform-none w-100", classes.btnLogout].join(" ")}
            onClick={logoutHandler}
          >
            <ExitToApp size={24} className="text-light-color mr-2" />
            <Typography variant="subtitle1" color="textSecondary" className="text-transform-none">
              LOGOUT
            </Typography>
          </Button>
        </div> */}
      </Fragment>
    );
  };
  return (
    <Box>
      {!isMobile && (
        <Card
          sx={{
            top: HEADER_HEIGHT + 10,
            left: menuPosition - 300,
          }}
          className={[classes.userMenuContainer, "z-l2", open ? "d-block" : "d-none"].join(" ")}
        >
          {userMenuContent()}
        </Card>
      )}
      {isMobile && (
        <Drawer anchor="bottom" open={open} onClose={onClose}>
          {userMenuContent()}
        </Drawer>
      )}
    </Box>
  );
};

export default UserMenu;

const CountryFlag = ({ code }) => {
  return (
    <ReactCountryFlag
      styleProps={{
        width: "28px",
        minWidth: "28px",
        height: "20px",
        borderRadius: "4px",
        backgroundSize: "cover",
      }}
      className="mr-2"
      code={code}
      svg
    />
  );
};
